import { ContentStatus, ContentSetData } from "./types/content.types";
import { TaskStatus, TaskDataMeta, TaskOption } from "./types/tasks.types";

const REQ_URL:string='https://gtlecomments.co.uk:3000';

interface ContentSendOb{
	comment:string;
	referrer:string;
	teachersType:string;
	outcome:boolean;
	isContentSetNew:boolean;
	title:string;
	user:string;
	link : string;
	contentLength :	number;
	items : string[];
	imCodes : string[];
	setID : number;
	audioID : number;
	date:string;
}

interface TaskSendOb {
	comment:string;
	referrer:string;
	teachersType:string;
	outcome:boolean;
	user:string;
	taskTitle: string;
	pageDir: string;
	contentType: string;
	classCode: string;
	contentTitle: string;
	taskOptions: TaskOption[];
	date:string;
	welcomeMsg:string;
};

export default class Monitoring{

	private myReq:XMLHttpRequest|null=null;

	constructor(){
		this.gotRequestResponse=this.gotRequestResponse.bind(this);
	}

	taskCreateClickOutcome(taskCreateStatus:TaskStatus,taskCreateData:TaskDataMeta){
		let myOutcome=taskCreateStatus===TaskStatus.CreateSuccess;
		let sendOb:TaskSendOb = {
			comment:'no comment',//avoid being blocked by server for empty comment
			referrer:'teachers',
			teachersType:'task',
			outcome:myOutcome,
			user:taskCreateData.creatorMail,
			taskTitle: taskCreateData.taskTitle,
			welcomeMsg: taskCreateData.welcomeMsg,

			pageDir: taskCreateData.pageDir,
			contentType: taskCreateData.contentType,
			classCode: taskCreateData.classCode,
			contentTitle: taskCreateData.contentTitle,
			taskOptions: taskCreateData.taskOptions,

			date:new Date().toLocaleString()
		};

		this.sendRequest(JSON.stringify(sendOb));
	}

	saveContentSetOutcome(contentStatus:ContentStatus,isContentSetNew:boolean,usermail:string,contentSetData:ContentSetData,setID:number){
		let myOutcome=contentStatus===ContentStatus.Default;
		let sendOb:ContentSendOb = {
			comment:'no comment',
			referrer:'teachers',
			teachersType:'content',
			outcome:myOutcome,
			isContentSetNew:isContentSetNew,
			title:contentSetData.title,
			user:usermail,
			link : usermail+'/'+contentSetData.title,
			contentLength :	contentSetData.imsList.length,
			items : contentSetData.txtsList,
			imCodes : contentSetData.imsList,
			setID : -1,
			audioID : -1,
			date:new Date().toLocaleString()
		};

		if(myOutcome){
			sendOb.setID=setID;
			if(contentSetData.options.length>0){
				sendOb.audioID=contentSetData.options[0].optVal;
			}
		}
		this.sendRequest(JSON.stringify(sendOb));
	}

	sendRequest(sendOb:string){
		if (this.myReq !== null) {
			this.myReq.removeEventListener('readystatechange', this.gotRequestResponse);
			this.myReq = null;
		}
		this.myReq = new XMLHttpRequest();
		this.myReq.addEventListener('readystatechange', this.gotRequestResponse);
		this.myReq.open('POST', REQ_URL, true);
		this.myReq.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		this.myReq.send(sendOb);
	}

	gotRequestResponse() {
		if (this.myReq?.readyState === 4 && this.myReq.status === 200) {
			this.myReq.removeEventListener('readystatechange', this.gotRequestResponse);
			this.myReq = null;
		}
	}
}